<template>
  <v-container>
    <section class="mt-2 mb-10">
      <!-- 대출 실행 단계에 따른 제목 -->
      <!-- 송금 대기중 -->
      <template v-if="isExecuting">
        <h1 v-if="me" class="font-size--24">
          {{ me.name }} 사장님!<br />
          모집된 대출금을 송금하기 위해 준비 중이에요!
        </h1>
        <ul class="font-size--13 pl-2 ml-n1 outer">
          <li>모집된 대출금의 입금 계좌는 선정산 입금 계좌와 동일합니다.</li>
        </ul>
      </template>

      <!-- 모집중 -->
      <template v-else-if="!isInvestComplete">
        <h1 class="mb-1 font-size--24">당겨받을 금액을 모으고 있어요!</h1>
        <ul class="font-size--13 pl-2 ml-n1 outer">
          <li>내일매출 당겨받기는 P2P 방식으로 온라인 모집하여 지급합니다.</li>
          <li>모집 기간은 1일이며, 신청하신 금액 중 일부만 모집-지급될 수 있습니다.</li>
          <li>모집된 금액은 신청 익일 오전 10시 이후 계약서 작성 후 송금됩니다.</li>
        </ul>
      </template>

      <!-- 모집 완료 -->
      <template v-else>
        <h1 v-if="me" class="font-size--24">
          {{ me.name }} 사장님!<br />
          모집이 완료되었어요!
        </h1>
      </template>
    </section>

    <!-- 모집 현황 -->
    <section class="mb-10">
      <v-layout justify-center>
        <v-progress-circular
          :value="investingPercent"
          width="10"
          color="primary"
          size="240"
          rotate="-90"
        >
          <div class="black--text text-center">
            <p class="color--nice-grey mb-1">모집중</p>
            <h1 class="font-size--24 mb-1">{{ commaFormat(investingAmount) }} 원</h1>
            <p v-if="loan">/{{ commaFormat(loan.amount) }} 원</p>
          </div>
        </v-progress-circular>
      </v-layout>
    </section>

    <!-- 계약서 작성 버튼 -->
    <section>
      <BasicButton
        depressed
        height="48"
        :loading="isLoading"
        :disabled="isLoading || !isInvestComplete || contractDisabled"
        @click="toContract"
      >
        <!-- 이미 계약서 작성한 경우 -->
        <template v-if="isExecuting">대출금 송금 준비 중</template>
        <!-- 모집 완료 -->
        <template v-else-if="isInvestComplete"> 클릭하여 계약서 작성하기 </template>
        <template v-else> 모집 중 </template>
      </BasicButton>
    </section>

    <v-footer fixed>
      <v-layout justify-center>
        <v-btn
          text
          color="grey"
          height="25"
          style="text-decoration: underline"
          :to="{ name: 'earlypay' }"
        >
          정산내역으로 돌아가기
        </v-btn>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { commaFormat } from '@/filter/number'

export default {
  data() {
    return {
      investingAmount: 0,
      loan: null,
      isLoading: false,
    }
  },
  computed: {
    ...mapState('auth', ['me']),

    /**
     * 대출 상태
     * 모집중 / 모집 완료 여부
     */
    isInvestComplete() {
      if (!this.loan || !this.investingAmount) return false

      // 모집 완료
      // 투자완료 상태 or 금액이 다 모집됨 or 작성 시간대 도달
      const completeStatus = this.loan.status === 'invested'

      return (this.isContractTime || completeStatus) && this.investingAmount > 0
    },

    /**
     * 대출 상태
     * 송금대기중
     */
    isExecuting() {
      return this.loan?.status === 'executing'
    },

    /**
     * 계약서 작성 가능 시간대 여부
     */
    isContractTime() {
      if (!this.loan) return false

      const now = this.$moment()
      const start = this.$moment(this.loan.contractStartTime)
      const end = this.$moment(this.loan.contractEndTime)

      return now.isSameOrAfter(start) && now.isBefore(end)
    },

    /**
     * 계약서 작성 버튼 비활성화 여부
     * 폐업 || 작성 가능 시간 아닌 경우 || 송금대기중
     */
    contractDisabled() {
      if (!this.me || !this.loan || !this.investingAmount) return true

      return this.me.store.isClosed || !this.isContractTime || this.isExecuting
    },

    /**
     * 모집 몇 퍼센트 완료됐는지
     */
    investingPercent() {
      if (!this.loan || !this.investingAmount) return 0
      return ((this.investingAmount / this.loan.amount) * 100).toFixed(0)
    },
  },
  async created() {
    const uuid = this.$route.params.uuid
    const [loan, investingAmount] = await Promise.all([
      this.getLoansDetail(uuid),
      this.getInvestingAmount(uuid),
    ])

    this.loan = loan
    this.investingAmount = investingAmount || 0
  },
  methods: {
    commaFormat,
    ...mapActions('loan', [
      'getLoansDetail',
      'getInvestingAmount',
      'closeLoan',
      'getLoansByOngoing',
    ]),

    /**
     * 계약서 작성하러 가기
     */
    async toContract() {
      if (this.isLoading) return

      this.isLoading = true
      try {
        // 모집 마감 시킨 후 이동
        await this.closeLoan(this.loan.uuid)
        // 대출 상태 업데이트
        await this.getLoansByOngoing()
        await this.$router.push({
          name: 'loan/contract',
          params: { uuid: this.loan.uuid },
        })
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
